import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import DialogueBase from '../../../components/dialogues/DialogueBase';
import { prettyLocalDate } from '../../../lib/time';
import { chooseIcon } from './ChooseIcon';
import Grid from '@material-ui/core/Grid';
import ControlButton from './ControlButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import DocumentCategoryChip from './DocumentCategoryChip';

const useStyles = makeStyles(() => ({
  doc: {
    padding: 0,
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
  },
  icon: {
    fontSize: '12rem',
  },
  button: {
    marginTop: '2rem',
  },
}));

const DocumentItemDetail = ({open, data, downloadFile, onClose}) => {
  const classes = useStyles();
  const from = (data.origin_name === null) ? data.origin : data.origin_name;
  const fileSize = bytes => (bytes / (1024*1024)).toFixed(2) + ' MB';
  return (
    <DialogueBase open={open} onClose={onClose} title="Document details">
      <Grid container spacing={3} className={classes.doc}>
        <Grid item lg={3} className={classes.center}>
          {chooseIcon(data.content_type, classes.icon)}
        </Grid>
        <Grid item lg={9} className={classes.leftCell}>
          <Table className={classes.table}>
            <TableBody>
              <TableRow>
                <TableCell>File name</TableCell>
                <TableCell>{data.name}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Type</TableCell>
                <TableCell>{data.content_type}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Size</TableCell>
                <TableCell>{fileSize(data.size)}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Created</TableCell>
                <TableCell>{prettyLocalDate(data.created_at)}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Source</TableCell>
                <TableCell>{from}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Category</TableCell>
                <TableCell>
                  <DocumentCategoryChip
                    data={data}
                    editable={false}
                  />
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
          <ControlButton
            label="Download file"
            icon="download"
            variant="contained"
            color="primary"
            onClick={()=>downloadFile(data.uuid)}
            className={classes.button}
          />
        </Grid>
      </Grid>
    </DialogueBase>
  );
};

DocumentItemDetail.propTypes = {
  open: PropTypes.bool.isRequired,
  data: PropTypes.object.isRequired,
  downloadFile: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default DocumentItemDetail;
